import FormComponent from "../../../../components/FormComponent";
import {css, html, nothing} from "@isceco/widget-library2/external/lit";
import {repeat} from '@isceco/widget-library2/external/lit/directives/repeat'
import '@isceco/widget-library2/basic-elements/Card/Card'
import '@isceco/widget-library2/basic-elements/Textarea/Textarea.js'
import '@isceco/widget-library2/basic-elements/DateInput/DateInput.js'
import '@isceco/widget-library2/basic-elements/NumberInput/NumberInput.js'

import ForschungsgesuchService from "./ForschungsgesuchService";

export default class Forschungsgesuch extends FormComponent {

  static MAX_ANTRAGSTELLER = 5;
  static PHONE_NUMBER_PATTERN = '^(?:0[0-9]{2}\\s*[0-9]{3}\\s*[0-9]{2}\\s*[0-9]{2}|0[0-9]{3}\\s*[0-9]{3}\\s*[0-9]{3}|(?:00|\\+)[0-9]{2}\\s*[0-9]{2,5}\\s*[0-9]{2,12})$';

  constructor() {
    super();
    this.antragsteller = [
      crypto.randomUUID() // there should always be one Antragsteller
    ]
  }

  get css() {
    return css`
      .column {
        display: flex;
        flex-direction: column;
        gap: var(--isceco-space-200);
      }

      .two-col-layout {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: var(--isceco-space-200);
        justify-content: space-between;
      }

      @media (min-width: 768px) {
        .two-col-layout {
          flex-direction: row;
        }
      }
    `
  }

  get translationFile() {
    return './views/WBF/BWO/Forschungsgesuch/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback();
    this.render();
  }

  getTemplate() {
    const submitKey = this.preview ? 'form.button.submit' : 'form.button.preview'
    return html`
      <isceco-title text="Forschungsgesuch"></isceco-title>
      <eform-submit-status></eform-submit-status>
      <isceco-form
        submit-button-text="${this.i18n.translate(submitKey)}"
        @submit="${e => this._submit(e)}"
        include-disabled
      >
        <div slot="buttons">
          <isceco-button text="${this.i18n.translate('form.button.abort')}"
                         @click="${() => this.abort()}"
                         variant="secondary"
                         .disabled="${!this.preview}"
          ></isceco-button>
        </div>
        <div slot="form-elements" style="display: flex; flex-direction: column; gap: var(--isceco-space-300)">
          ${this._renderProjekttitel()}
          ${this._renderAntragstellendePerson()}
          ${this._renderForschungsprojekt()}
          ${this._renderForschungsgesuch()}
        </div>
      </isceco-form>
    `
  }

  _renderProjekttitel() {
    return html`
      <isceco-card text="Projekttitel*">
        <isceco-text-input
          label=""
          name="projekt.titel"
          required
          .readonly="${this.preview}">
        </isceco-text-input>
      </isceco-card>
    `
  }

  _renderAntragstellendePerson() {
    const disabledAddButtonTitle = this.antragsteller.length >= Forschungsgesuch.MAX_ANTRAGSTELLER ? this.i18n.translate('form.request.antragsteller.add.info', {max: Forschungsgesuch.MAX_ANTRAGSTELLER}) : undefined
    return html`
      <isceco-card text="Antragstellende Person(en)">
        ${repeat(this.antragsteller, antragsteller => antragsteller, (antragsteller, index) => html`
          <div class="column">
            ${this._renderAdditionalAntragstellerTitle(index)}
            <div class="two-col-layout">
              <isceco-text-input label="${this.i18n.translate('form.request.antragsteller.vorname')}"
                                 name="antragsteller${index}.vorname"
                                 required
                                 .readonly="${this.preview}"
                                 style="flex:1"
              ></isceco-text-input>
              <isceco-text-input label="${this.i18n.translate('form.request.antragsteller.nachname')}"
                                 name="antragsteller${index}.nachname"
                                 required
                                 .readonly="${this.preview}"
                                 style="flex:1"
              ></isceco-text-input>
            </div>
            <isceco-text-input label="${this.i18n.translate('form.request.antragsteller.funktion')}"
                               name="antragsteller${index}.funktion"
                               required
                               .readonly="${this.preview}"
            ></isceco-text-input>
            <isceco-text-input label="${this.i18n.translate('form.request.antragsteller.institution')}"
                               name="antragsteller${index}.institution"
                               required
                               .readonly="${this.preview}"
            ></isceco-text-input>
            <div class="two-col-layout">
              <isceco-text-input label="${this.i18n.translate('form.request.antragsteller.email')}"
                                 name="antragsteller${index}.email"
                                 type="email"
                                 pattern-error-text="${this.i18n.translate('form.request.antragstelelr.email.error')}"
                                 required
                                 .readonly="${this.preview}"
                                 style="flex: 1"
              ></isceco-text-input>
              <isceco-text-input label="${this.i18n.translate('form.request.antragsteller.telefonnummer')}"
                                 name="antragsteller${index}.telefonnummer"
                                 pattern="${Forschungsgesuch.PHONE_NUMBER_PATTERN}"
                                 pattern-error-text="${this.i18n.translate('form.request.antragstelelr.telefonnummer.error')}"
                                 required
                                 .readonly="${this.preview}"
                                 style="flex: 1"
              ></isceco-text-input>
            </div>
          </div>
        `)}
        <isceco-button
          style="margin-top: var(--isceco-space-300)"
          variant="primary"
          text="${this.i18n.translate('form.request.antragsteller.add')}"
          icon="plus"
          .title="${disabledAddButtonTitle}"
          .disabled="${this.antragsteller.length >= Forschungsgesuch.MAX_ANTRAGSTELLER || this.preview}"
          @click="${() => this._addPerson()}"
        ></isceco-button>
      </isceco-card>
    `
  }

  _renderAdditionalAntragstellerTitle(index) {
    const displayCount = index + 1;
    return index <= 0 ? nothing : html`
      <div style="margin-top: var(--isceco-space-300)">
        <hr style="border-top: 1px dashed; width: 100%">
        <div
          style="display: flex; align-items: center; justify-content: space-between; width: 100%">
          <h3>
            ${this.i18n.translate('form.request.antragsteller.title', {count: displayCount})}
            <span style="font-size: small">/ ${Forschungsgesuch.MAX_ANTRAGSTELLER}</span>
          </h3>
          <isceco-button
            variant="danger"
            size="small"
            icon="minus"
            .disabled="${this.preview}"
            @click="${() => this._removePerson(index)}"
          ></isceco-button>
        </div>
      </div>
    `
  }

  _addPerson() {
    if (this.antragsteller.length < Forschungsgesuch.MAX_ANTRAGSTELLER) {
      this.antragsteller.push({renderId: crypto.randomUUID()})
      this.render()
    }
  }

  _removePerson(index) {
    if (this.antragsteller.length > 1 && index !== 0) {
      const targetIndex = index - 1;
      this.antragsteller.splice(targetIndex, 1);
      this.render()
    }
  }

  _renderForschungsprojekt() {
    return html`
      <isceco-card text="Forschungsprojekt">
        <div class="column">
          <div class="two-col-layout">
            <isceco-date-input
              label="${this.i18n.translate('form.request.forschungsprojekt.startdatum')}"
              .readonly="${this.preview}"
              style="flex: 1"
              name="forschungsprojekt.startdatum"
              type="date"
              required
            ></isceco-date-input>
            <isceco-number-input
              label="${this.i18n.translate('form.request.forschungsprojekt.laufzeit')}"
              .readonly="${this.preview}"
              style="flex: 1"
              name="forschungsprojekt.laufzeit"
              min="0"
              required
            ></isceco-number-input>
          </div>
          <div class="two-col-layout">
            <isceco-number-input
              label="${this.i18n.translate('form.request.forschungsprojekt.gesamtaufwand')}"
              .readonly="${this.preview}"
              style="flex: 1"
              name="forschungsprojekt.gesamtaufwand"
              min="0"
              required
            ></isceco-number-input>
            <isceco-number-input
              label="${this.i18n.translate('form.request.forschungsprojekt.unterstuetzung')}"
              .readonly="${this.preview}"
              style="flex: 1"
              name="forschungsprojekt.unterstuetzung"
              min="0"
              required
            ></isceco-number-input>
          </div>
          <isceco-textarea
            name="forschungsprojekt.stellen"
            label="${this.i18n.translate('form.request.forschungsprojekt.stellen')}"
            placeholder="${this.i18n.translate('form.request.forschungsprojekt.stellen.placeholder')}"
            maxlength="1000"
            rows="4"
            .readonly="${this.preview}"
            required
          ></isceco-textarea>
          <isceco-textarea
            name="forschungsprojekt.projektbeschrieb"
            label="${this.i18n.translate('form.request.forschungsprojekt.projektbeschrieb')}"
            placeholder="${this.i18n.translate('form.request.forschungsprojekt.projektbeschrieb.placeholder')}"
            maxlength="2000"
            rows="4"
            .readonly="${this.preview}"
            required
          ></isceco-textarea>
          <isceco-textarea
            name="forschungsprojekt.fragestellung"
            label="${this.i18n.translate('form.request.forschungsprojekt.fragestellung')}"
            placeholder="${this.i18n.translate('form.request.forschungsprojekt.fragestellung.placeholder')}"
            maxlength="1000"
            rows="4"
            .readonly="${this.preview}"
            required
          ></isceco-textarea>
          <isceco-textarea
            name="forschungsprojekt.projektziel"
            label="${this.i18n.translate('form.request.forschungsprojekt.projektziel')}"
            placeholder="${this.i18n.translate('form.request.forschungsprojekt.projektziel.placeholder')}"
            maxlength="1000"
            rows="4"
            .readonly="${this.preview}"
            required
          ></isceco-textarea>
          <isceco-textarea
            name="forschungsprojekt.methodik"
            label="${this.i18n.translate('form.request.forschungsprojekt.methodik')}"
            placeholder="${this.i18n.translate('form.request.forschungsprojekt.methodik.placeholder')}"
            maxlength="2000"
            rows="4"
            .readonly="${this.preview}"
            required
          ></isceco-textarea>
          <isceco-textarea
            name="forschungsprojekt.anknuepfung"
            label="${this.i18n.translate('form.request.forschungsprojekt.anknuepfung')}"
            placeholder="${this.i18n.translate('form.request.forschungsprojekt.anknuepfung.placeholder')}"
            maxlength="1000"
            rows="4"
            .readonly="${this.preview}"
            required
          ></isceco-textarea>
          <isceco-textarea
            name="forschungsprojekt.wissensluecke"
            label="${this.i18n.translate('form.request.forschungsprojekt.wissensluecke')}"
            placeholder="${this.i18n.translate('form.request.forschungsprojekt.wissensluecke.placeholder')}"
            maxlength="2000"
            rows="4"
            .readonly="${this.preview}"
            required
          ></isceco-textarea>
          <isceco-textarea
            name="forschungsprojekt.bemerkung"
            label="${this.i18n.translate('form.request.forschungsprojekt.bemerkung')}"
            placeholder="${this.i18n.translate('form.request.forschungsprojekt.bemerkung.placeholder')}"
            maxlength="2000"
            rows="4"
            .readonly="${this.preview}"
          ></isceco-textarea>
        </div>
      </isceco-card>
    `
  }

  _renderForschungsgesuch() {
    return html`
      <isceco-card text="Forschungsgesuch" style="margin-bottom: var(--isceco-space-200)">
        <isceco-file-input label="${this.i18n.translate('form.request.forschungsgesuch.attachments')}"
                           help-text="${this.i18n.translate('form.request.forschungsgesuch.attachments.info')}"
                           accept=".pdf,application/pdf"
                           name="attachments"
                           multiple
                           maxfiles="25"
                           maxsize="${this.fileMaxSize}"
                           .fileInputService="${this.fileInputService}"
                           .disabled="${this.preview}"
                           required
        ></isceco-file-input>
      </isceco-card>
    `
  }

  _submit(event) {
    if (!this.preview) {
      this.preview = true
      this.render()
      return;
    }

    new ForschungsgesuchService().submit(event.detail, event.target)
  }
}

customElements.define('wbf-bwo-forschungsgesuch', Forschungsgesuch);
